<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M9.5 6C7 7.3 5.5 9.6 5.5 12.6V18h5.2v-5.4H8.2c0-1.9.6-3.3 2.3-4.3z" />
    <path d="M18.3 6c-2.5 1.3-4 3.6-4 6.6V18h5.2v-5.4H17c0-1.9.6-3.3 2.3-4.3z" />
  </svg>
</template>
